import { motion } from 'framer-motion';

const EASE = [0.22, 1, 0.36, 1];

// Block reveal — fades and lifts into view once.
export const Reveal = ({
  children,
  delay = 0,
  y = 26,
  duration = 0.85,
  className = '',
  as = 'div',
  ...rest
}) => {
  const Tag = motion[as] || motion.div;
  return (
    <Tag
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-12% 0px -8% 0px' }}
      transition={{ duration, delay, ease: EASE }}
      className={className}
      {...rest}
    >
      {children}
    </Tag>
  );
};

// Line-by-line masked reveal for display headlines.
export const RevealLines = ({ lines = [], delay = 0, className = '', lineClassName = '' }) => (
  <span className={`block ${className}`}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: '110%' }}
          whileInView={{ y: '0%' }}
          viewport={{ once: true, margin: '-10% 0px' }}
          transition={{ duration: 1.05, delay: delay + i * 0.11, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

// Stagger container for grids/lists.
export const Stagger = ({ children, className = '', gap = 0.09, delay = 0 }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="shown"
    viewport={{ once: true, margin: '-8% 0px' }}
    variants={{ shown: { transition: { staggerChildren: gap, delayChildren: delay } } }}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className = '', y = 30, ...rest }) => (
  <motion.div
    className={className}
    variants={{
      hidden: { opacity: 0, y },
      shown: { opacity: 1, y: 0, transition: { duration: 0.8, ease: EASE } },
    }}
    {...rest}
  >
    {children}
  </motion.div>
);

export default Reveal;
